import React from "react";
import DoctorMiniCard from "../global/DoctorMinCard";

export default function HomeRecommendedDoctors({
  doctors = [],
  onSeeAll,
  onOpenDoctor,
}) {
  if (!doctors.length) return null;

  return (
    <section className="p2-reco-section">
      <div className="p2-reco-header">
        <p className="p2-reco-title">Mjekët e rekomanduar për ty</p>

        {onSeeAll && (
          <button
            type="button"
            onClick={onSeeAll}
            className="p2-reco-seeall"
          >
            Shiko më shumë
          </button>
        )}
      </div>

      {/* Horizontal scroll, like cards in the screenshot */}
      <div className="p2-reco-scroll p2-scroll-no-bar">
        {doctors.map((d) => (
          <div key={d.id} className="p2-reco-card-wrap">
            <DoctorMiniCard
              avatarUrl={d.avatarUrl}
              initials={d.initials}
              name={d.name}
              specialty={d.specialty}
              subtitle={d.subtitle} // p.sh. "800m larg • 4.8 ★"
              actionLabel="Shiko profilin"
              onAction={() => onOpenDoctor?.(d)}
              onClick={() => onOpenDoctor?.(d)}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
